import React from "react"
import Issued from "./Issued"
import Sizes from "./Sizes"
import { Divider } from "antd"
import useSchedulesQueryParams from "hooks/useSchedulesQueryParams"
import { useEmployeeScheduleDefaults } from "hooks/useScheduleDefaults"

const Equipments: React.FC = () => {
	useEmployeeScheduleDefaults()
	const { selectedEmployee = "" } = useSchedulesQueryParams()
	return (
		<>
			<Issued selected={selectedEmployee} />
			<Divider />
			<Sizes selected={selectedEmployee} />
		</>
	)
}

export default Equipments
